export default {
    url: '/performance-review/:id',
    template: `
        <review-default review="vm.review"></review-default>
        `,
    resolve: {
        review ($stateParams, ReviewResource, ReviewService) {
            return ReviewResource.get({ id: $stateParams.id, expand: ReviewService.getExpandString() }).$promise;
        }
    },
    controller ($stateParams, $scope, MomentService, ReviewService, review) {
        ReviewService.loadAdditionalData(review, true);
        this.review = review;
        this.review.reviewDate = MomentService.formatTimeStamp(review.reviewDate, 'YYYY-MM-DD HH:mm:00', true);
        this.review.isReadOnly = true;
        this.review.isManageView = true;
    }
};



// WEBPACK FOOTER //
// ./src/app/states/authorized/review/manage/index.js